<template>
   
      
        <div class="how-to-play container">

        <div id="rules">
        <h1>How to play</h1>
        <ul>
        <li><span>1</span>Choose your department, then Press start to deal 5 cards and start the timer.</li>
        <li><span>2</span>Participant(s) prioritise cards in order of clinical urgency. 'I'm Done' is pressed to pause timer.</li>
        <li><span>3</span>Facilitator selects 3 cards and from the list and puts them into the "Jobs Done" pile.</li>
        <li><span>4</span>3 more scenarios are dealt, the remaining cards are reshuffled into a new order, the clock is restarted and participant re-prioritises.</li>
        <li><span>5</span>The cycle is repeated until the deck is empty or when time runs out.</li>
       
        </ul>
        </div>

        <div id="points">
            <h1>Points of reflection</h1>
            <ul>
            <li><span>1</span>What assumptions am I having to make about a job request?</li>
            <li><span>2</span>What extra information would help me to make a decision?</li>
            <li><span>3</span>Would more information help?</li>
            <li><span>4</span>Why am I choosing these jobs before others?</li>
            <li><span>5</span>What would change my mind about a job’s priority?</li>
            <li><span>6</span>What strategies could I use to help with prioritising?</li>
            <li><span>7</span>Which jobs can be delegated and who can these be delegated to?</li>
        </ul>
        </div>
    </div>
</template>